<template>
<div class="masters">


	<div class="master-title">
		<div class="title">Мастер-классы</div>
		Бренд-шеф White Rabbit и один из лучших шеф-поваров мира Владимир Мухин рассказывает об идеальных сочетаниях вкусов
	</div>



	<template v-if="!$mobile">
		<div class="row">
			<div class="master one">
				<div class="text">Морковник с арбузом и Aqua Minerale "Черешня"</div>
				<div class="video" @click="openVideo('cherry')">
					<div class="bg" />
					<div class="inner">
						<div class="triangle" />
					</div>
				</div>
			</div>
			<div class="master two">
				<div class="video" @click="openVideo('lime')">
					<div class="bg" />
					<div class="inner">
						<div class="triangle" />
					</div>
				</div>
				<div class="text">Ягненок с черным перцем и Aqua Minerale "Мята-Лайм"</div>
			</div>
		</div>

		<div class="row">
			<div class="master three">
				<div class="text">Эклеры с копченым лососем и Aqua Minerale "Лимон"</div>
				<div class="video" @click="openVideo('lemon')">
					<div class="bg" />
					<div class="inner">
						<div class="triangle" />
					</div>
				</div>
			</div>
			<div class="master four">
				<div class="video" @click="openVideo('apple')">
					<div class="bg" />
					<div class="inner">
						<div class="triangle" />
					</div>
				</div>
				<div class="text">Цесарка с яблоками и Aqua Minerale "Яблоко"</div>
			</div>
		</div>
	</template>




	<div class="all" v-else>
		<div class="mastermob one">
			<div class="text">Морковник с арбузом и Aqua Minerale "Черешня"</div>
			<div class="video" @click="openVideo('cherry')">
				<div class="bg" />
				<div class="inner">
					<div class="triangle" />
				</div>
			</div>
		</div>
		<div class="mastermob two">
			<div class="text">Ягненок с черным перцем и Aqua Minerale "Мята-Лайм"</div>
			<div class="video" @click="openVideo('lime')">
				<div class="bg" />
				<div class="inner">
					<div class="triangle" />
				</div>
			</div>
		</div>
		<div class="mastermob three">
			<div class="text">Эклеры с копченым лососем и Aqua Minerale "Лимон"</div>
			<div class="video" @click="openVideo('lemon')">
				<div class="bg" />
				<div class="inner">
					<div class="triangle" />
				</div>
			</div>
		</div>
		<div class="mastermob four">
			<div class="text">Цесарка с яблоками и Aqua Minerale "Яблоко"</div>
			<div class="video" @click="openVideo('apple')">
				<div class="bg" />
				<div class="inner">
					<div class="triangle" />
				</div>
			</div>
		</div>
	</div>
	
</div>
</template>



<script>
import Events from '@/events'

export default {
	name: 'Masters',
	methods: {
		openVideo(type) {
			Events.$emit('open-video', type)
		},
	},
}
</script>


<style lang="less" scoped>
@import "../assets/app.less";

.masters {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-image: url(../assets/water.png);
	background-size: cover;

	.row {
		max-width: 1000px;
		display: flex;
		margin-bottom: 30px;
	}

	.master-title {
		text-align: center;
		max-width: 720px;
		margin-bottom: 60px;
		font-size: 20px;
		line-height: 28px;

		.title {
			font-size: 42px;
			padding-bottom: 15px;
			text-transform: uppercase;
			color: @gold;
			letter-spacing: 2px;
		}

	}

	.master {
		display: flex;
		width: 100%;
		margin-bottom: 20px;
	}

	.text {
		font-size: 14px;
		text-align: right;
		margin-right: 10px;
	}

	.master.two {
		margin-left: 50px;

		.text {
			text-align: left;
			margin-left: 20px;
		}
	}

	.master.four {
		margin-left: 50px;

		.text {
			text-align: left;
			margin-left: 20px;
		}
	}

	.triangle {
		width: 60px;
		height: 60px;
		position: absolute;
		border: 2px solid rgba(255, 255, 255, 0.5);
		border-radius: 30px;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);

		&:after {
			content: "";
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateX(-40%) translateY(-50%);
			width: 0;
			height: 0;
			border-top: 15px solid transparent;
			border-bottom: 15px solid transparent;
			border-left: 24px solid #fff;
		}
	}

	.video {
		flex-shrink: 0;
		width: 320px;
		height: 180px;
		position: relative;
		cursor: pointer;

		&:hover {
			.inner {
				transform: scale(0.97);
			}
		}

		.bg {
			width: 100%;
			height: 100%;
			position: absolute;
			transform: translateX(10px) translateY(-10px);
		}

		.inner {
			width: 100%;
			height: 100%;
			position: absolute;
			transition: all 600ms ease;
			background: #000;
			background-size: cover;
		}
	}

	.master.one .video {
		.bg {
			background: #d20057;
		}
		.inner {
			background: url(../assets/video1.png);
			background-size: cover;
		}
	}

	.master.two .video {
		.bg {
			background: #cbd514;
		}
		.inner {
			background: url(../assets/video2.png);
			background-size: cover;
		}
	}
	.master.three .video {
		.bg {
			background: #fcd800;
		}
		.inner {
			background: url(../assets/video4.png);
			background-size: cover;
		}
	}
	.master.four .video {
		.bg {
			background: #e94e1e;
		}
		.inner {
			background: url(../assets/video3.png);
			background-size: cover;
		}
	}

}


@media only screen and (max-width: 1000px) {


.masters {
	padding: 60px 0;

	.master-title {
		width: 80%;
		font-size: 16px;
		line-height: 22px;
		margin-bottom: 50px;

		.title {
			font-size: 26px;
		}
	}

	.mastermob {
		width: 100%;
		display: flex;
		flex-direction: column-reverse;
		padding: 0;
		margin: 0;
	}

	.text {
		width: 80%;
		margin: 0 auto;
		margin-top: 10px;
		margin-bottom: 30px;
		text-align: center;
	}

	.video {
		width: 80%;
		margin: 0 auto;

		&:hover {
			.inner {
				transform: none;
			}
		}
	}

	

	.mastermob.one .video {
		.bg {
			background: #d20057;
		}
		.inner {
			background: url(../assets/video1.png);
			background-size: cover;
			background-position: right center;
		}
	}

	.mastermob.two .video {
		.bg {
			background: #cbd514;
		}
		.inner {
			background: url(../assets/video2.png);
			background-size: cover;
			background-position: right center;
		}
	}
	.mastermob.three .video {
		.bg {
			background: #fcd800;
		}
		.inner {
			background: url(../assets/video4.png);
			background-size: cover;
		}
	}
	.mastermob.four .video {
		.bg {
			background: #e94e1e;
		}
		.inner {
			background: url(../assets/video3.png);
			background-size: cover;
		}
	}


}



}



</style>